export const combineFilters = (...filters) => (item) => {
  return filters.map(filter => filter(item)).every(Boolean);
};
